<template>
  <donut-slack-preview :hide-name="true" :message="message" />
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { getters } = useStore();
  const props = defineProps({
    points: { type: Number, default: 7 },
    config: { type: Object, default: null },
  });

  const namePhrase = computed(() => {
    const names = ['bernardo', 'arielle', 'ricky'].map(n => `:::@${n}:::`);
    if (props.points === 1) return names[0];
    if (props.points === 2) return `${names[0]} and ${names[1]}`;
    if (props.points === 3) return `${names[0]}, ${names[1]}, and ${names[2]}`;
    if (props.points > 3) return `${names.join(', ')}, and ${props.points - 3} others`;
  });
  const message = computed(() => `You received *${getters['pointsConfig/pointsPhraseFromConfig'](props)}* from `
    + `${namePhrase.value} on this message.`);
</script>
